import { createAction } from '../../../store.model';
import { Meeting } from '../../core';
import { ActionType } from '../transcript-import-dialog.action';

export interface ReceiveMeetings {
    meetings: Meeting[] | null;
}

export const receiveMeetings = createAction<ActionType, ReceiveMeetings>(
    ActionType.TC__TI__RECEIVE_MEETINGS,
);
